import React, { useState, useEffect, CSSProperties } from 'react';
import { useNavigate } from "react-router-dom";
import { DeleteUserButton } from 'components/delete-button';
import { ListItem } from 'components/list-item/list-item';
import i18n from '../../i18n';
import { runBasedOnCoutries } from '../../util';

export const MainPage = () => {
  const navigate = useNavigate();
  const [showWarning, setShowWarning] = useState(false);

  let headerStyle: CSSProperties = {
    lineHeight: '16px',
    paddingTop: '40px'
  }

  useEffect(() => {
    // In case we have access token, redirect to delete page
    let accessToken = window.sessionStorage.getItem('access_token');
    if (accessToken) {
      navigate('/delete');
    }

    let pleaseRead = i18n.t('PleaseRead');
    let importatnt = i18n.t('Important');
    if (pleaseRead.length > 0 && importatnt.length > 0) {
      setShowWarning(true);
      // eslint-disable-next-line 
      headerStyle = {
        lineHeight: '16px',
        paddingTop: '40px',
        marginBottom: '32px'
      }
    }
  }, [showWarning, navigate]);

  const listDataDefault = [
    { image: "/loan_paid.svg", title: "Installment", text: "DeleteWillNotImpactAgreement" },
    { image: "/cash.svg", title: "SettleBalances", text: "DeleteImpactBalances" },
    { image: "/account.svg", title: "DeleteAccountAffected", text: "DeleteAccountMyHomeCredit" },
    { image: "/folder_open.svg", title: "DataHandling", text: "WeWillRetainData" },
    { image: "/monthly_statements.svg", title: "NoLoanChecking", text: "AppProvidesLoanInfo" },
    { image: "/marketplace.svg", title: "NoAccessToOffers", text: "MissingDealsAndPromotions" },
    { image: "/cash_loan.svg", title: "NoLoansOverview", text: "DeleteNoAccessAndroid" },
    { image: "/best_gifts.svg", title: "NoAccessToOffersAndPromotions", text: "DeleteMissOfferings" },
  ]

  const listDataEnId = [
    { image: "/alert.svg", title: "DeleteProcedure", text: "DeletionRequest" },
    { image: "/application_rejected.svg", title: "DeleteRejection", text: "RefuseDeletion" },
    { image: "/folder_open.svg", title: "KeepData", text: "RetainAccountArchives" },
  ]

  let listData;

  if (runBasedOnCoutries(['id', 'en'])) {
    listData = listDataEnId;
  } else {
    listData = listDataDefault;
  }

  return (
    <>
      <nav className="navbar navbar-light sticky-top">
        <h1 className="page-title" data-testid="page-title">{i18n.t('DeleteTitle')}</h1>
      </nav>
      <div className="row" style={{ marginRight: '0px' }}>
        <div className="col-12 text-center">
          <img src='/bin.svg' className="header" alt="header logo" data-testid="header-logo"/>
        </div>

        <div className="col-12">
          <h1 data-testid="delete-account-header" style={headerStyle}>{i18n.t('YouDeleteYourAccount')}</h1>
          {showWarning && <p data-testid="please-read-text">{i18n.t('PleaseRead')}<h2 style={{ paddingTop: '32px' }}>{i18n.t('Important')}</h2></p>}
        </div>
        {listData!.map((data: any, index: number) => (
          <ListItem dataTestId={`list-item-${index}`} key={index} image={data.image} title={data.title} text={data.text} />
        ))}

        <DeleteUserButton />
      </div>
    </>
  );
};